import React from 'react';
import { Box, TablePagination } from '@mui/material';

interface EnhancedTablePaginationProps {
  count: number;
  rowsPerPage: number;
  page: number;
  onPageChange: (event: unknown, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  rowsPerPageOptions?: number[];
  showFirstButton?: boolean;
  showLastButton?: boolean;
}

const EnhancedTablePagination: React.FC<EnhancedTablePaginationProps> = ({
  count,
  rowsPerPage,
  page,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [5, 10, 25, 50, 100],
  showFirstButton = false,
  showLastButton = false,
}) => {
  return (
    <Box
      // Ensure this box never scrolls and doesn’t shrink
      sx={{ 
        flexShrink: 0, 
        overflow: 'hidden', 
        display: 'flex', 
        justifyContent: 'flex-end' 
      }}
    >
      <TablePagination
        component="div"              // render as a div, not a table cell
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={rowsPerPageOptions}
        showFirstButton={showFirstButton}
        showLastButton={showLastButton}
        // also override any internal overflow just in case
        sx={{ overflow: 'visible' }}
      />
    </Box>
  );
};
 
export default EnhancedTablePagination; 